import { Link } from 'react-router';
import Functions from '../../../functions';
import iconFile from '../../assets/images/icon_stimulus.gif';
import type { ItemStimulus } from '../../lib/ItemUtil';
import ListBase, { type ListBaseProps } from '../lib/ListBase';

class StimulusList extends ListBase {
    constructor(props: ListBaseProps) {
        super(props);
        this.label = 'Stimulus';
        this.icon = iconFile;
    }

    renderBody() {
        const { lang } = this.props;
        const item = this.props.item as ItemStimulus;
        const authors = item.developer.map((author) => Functions.mlang(author, lang)).join(', ');
        return (
            <>
                <Link to={this.url}>{Functions.mlang(item.title, lang)}</Link>
                <br />
                {authors}
            </>
        );
    }
}

export default StimulusList;
